import type { MediaSetting } from "@circle-react/types/MediaSetting";
import { VideoPlayer } from "../../VideoPlayer";
import type { VideoPlayerApi } from "../../VideoPlayer";
import type { VideoMetadata } from "../../VideoPlayer/types";

interface MediaPreviewProps {
  chaptersUrl?: string;
  mediaSettings: MediaSetting;
  onLoadedMetadata?: (metadata: VideoMetadata) => void;
  onPlayerReady?: (api: VideoPlayerApi) => void;
  onTimeUpdate?: (time: number) => void;
}

export const MediaPreview = ({
  mediaSettings,
  chaptersUrl,
  onTimeUpdate,
  onLoadedMetadata,
  onPlayerReady,
}: MediaPreviewProps) => (
  <VideoPlayer
    src={mediaSettings.blob_url}
    contentType={mediaSettings.blob_content_type}
    mediaTranscoding={mediaSettings.transcoding}
    mediaTranscriptId={mediaSettings.transcript?.id ?? undefined}
    downloadUrl={mediaSettings.blob_url}
    downloadable={mediaSettings.make_downloadable}
    settingsEnabled={false}
    isVideoAnalyticsEnabled={false}
    posterUrl={
      mediaSettings.custom_thumbnail_url ?? mediaSettings.default_thumbnail_url
    }
    chaptersUrl={chaptersUrl}
    previewThumbnailsUrl={mediaSettings.preview_thumbnails_url}
    variants={mediaSettings.video_variants}
    signedId={mediaSettings.blob_signed_id}
    onTimeUpdate={onTimeUpdate}
    onLoadedMetadata={onLoadedMetadata}
    onPlayerReady={onPlayerReady}
    preload="metadata"
  />
);
